(function() {
    angular.module('NaviaqWebApp').constant('appVersion','26.09.04.1502');
})();
